// Blacklist containing possible bad words in Dutch and English
const blacklist = ['banus', 'bof', 'boner', 'bug', 'bum', 'coq', 'cum', 'dom', 'dop', 'dope', 'duwen', 'fag', 'fap', 'fuk',
 'gay', 'gek', 'homo', 'hor', 'jemig', 'jezus', 'jiz', 'kak', 'kater', 'kike', 'kut', 'lul', 'moron', 'nemen', 'nig', 'niger',
  'palen', 'penis', 'pik', 'pot', 'rape', 'rapin', 'satan', 'semen', 'sex', 'tit', 'tyfus', 'zak', 'puta', 'cona', 'pila', 'sexo','tora']

// A selection of letters (conflicting letter like `i` and `l` are ommitted)
const consonants = ['b', 'c', 'd', 'f', 'g', 'h', 'k', 'p', 'q', 'r', 's', 't', 'v', 'w']
const vowels = ['a', 'e', 'i', 'o', 'u']

// Generate the bime
const generateBime = ({ length } = { length: 6 }) => {
  const letters = []
  for (let index = 0; index < length; index++) {
    const list = (index % 2) ? vowels : consonants
    const letter = list[Math.floor(Math.random() * list.length)]
    letters.push(letter)
  }
  const bime = letters.join('')
  for (const badWord of blacklist) if (bime.indexOf(badWord) > -1) return generateBime({ length })
  return bime
}

export default generateBime
